<template>
    <Layout>
        <div class="content">
            <section class="app-main">
                <transition name="fade-transform" mode="out-in">
                    <keep-alive >
                        <PageInfo class="mt50" :info="infoText||defaultDesc" />
                    </keep-alive>
                </transition>
            </section>
        </div>
    </Layout>
</template>

<script>
    import Layout from '@/layout/index.vue';
    import PageInfo from '@/components/noPermissionInfo';

    export default {
        name: 'NoPermissionComp',
        components: {
            Layout,
            PageInfo,
        },
        data() {
            return {
                infoText:'',
            }
        },
        computed:{
            defaultDesc(){
                let routeMeta = this.$route.meta||{};
                return routeMeta.desc||'';
            }
        },
        created() {

        },
        methods: {}
    }
</script>

<style lang="scss" scoped>
    .content {
        background-color: #fff;
        min-height: calc(100vh - 84px);
        font-size: 12px;
        padding-top: 20px;
    }


</style>
